export default __webpack_public_path__ + "static/media/log-out-nav.770bf6de.svg";